import { Field } from "../../field";
import { BusinessOwner, StoreLocation } from "../../fieldsets";
import { Merchant } from "../../merchant";

import { determineNonOwnerApplicable, determineOwnerApplicable } from "./utils";

export class StreetField extends Field<string> {
  protected readonly _collection: BusinessOwner | StoreLocation | null;

  constructor(
    model: Merchant,
    collection: BusinessOwner | StoreLocation | null,
    { propertyName }: { propertyName: string }
  ) {
    super(model, {
      dataType: "string",
      testValue: "111 street",
      propertyName,
      // for now only company info street uses autocomplete
      uiFieldType: "LocationAutocomplete",
    });

    this._collection = collection;
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    if (this._collection instanceof BusinessOwner) {
      return determineOwnerApplicable(registeredCountry);
    } else if (this._collection instanceof StoreLocation) {
      return true;
    }

    // non collection related (ie company information)
    return determineNonOwnerApplicable(registeredCountry, businessType);
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
